/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {useStore} from '../../../../store/store';
import {observer} from 'mobx-react';
import PageWrapper from '../../../modules/PageWrapper';
import Filters from '../../../table/sales/filters/Filters';
import Presets from '../../../table/sales/Presets';
import {getFilters} from './getFilters';
import {filtersAll, filtersHeadOfSales, filtersTeamlead, filtersManager} from './filtersConfigs';
import {groupsAll, groupsHeadOfSales, groupsTeamleader, groupsManager} from './groupsConfigs';
import TableWrapper from '../../../table/sales/TableWrapper';
import Columns from '../../../table/sales/Columns';
import {baseFields} from '../../../table/sales/customizationTable';
import BlankSheet from '../../../table/sales/BlankSheet';
import FullScreen from '../../../table/sales/FullScreen';
import Refresh from '../../../table/sales/Refresh';
import ResultsCount from '../../../table/sales/ResultsCount';
import Navigation from '../../../modules/NavigationBloggers';

const Statistics = () => {
  const store = useStore();
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);

  const getListFilters = () => {
    if (store.roles.includes(8) || store.roles.includes(30)) {
      return filtersHeadOfSales;
    }
    if (store.roles.includes(16) || store.roles.includes(17)) {
      return filtersTeamlead;
    }
    if (store.roles.includes(9) || store.roles.includes(15)) {
      return filtersManager;
    }

    if (
      store.roles.includes(39) ||
      store.roles.includes(32) ||
      store.roles.includes(13) ||
      store.roles.includes(38) ||
      store.roles.includes(4)
    ) {
      return filtersAll;
    }

    return [];
  };

  const getListGroups = () => {
    if (store.roles.includes(8) || store.roles.includes(30)) {
      return groupsHeadOfSales;
    }
    if (store.roles.includes(16) || store.roles.includes(17)) {
      return groupsTeamleader;
    }
    if (store.roles.includes(9) || store.roles.includes(15)) {
      return groupsManager;
    }

    if (
      store.roles.includes(39) ||
      store.roles.includes(32) ||
      store.roles.includes(13) ||
      store.roles.includes(38) ||
      store.roles.includes(4)
    ) {
      return groupsAll;
    }

    return [];
  };

  return (
    <PageWrapper
      firstTimeConfig='current_week'
      prevTimeConfig={prevTimeConfig}
      breadcrumbs={[
        {title: 'Отдел продаж'},
        {isSeparator: true},
        {
          title: 'Статистика RD',
          path: '/sales/rd/statistics',
          isActive: true,
        },
      ]}
      title='Статистика RD'
    >
      <TableWrapper
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'sales/rd/statistics'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={null}
        defaultFilters={[{filter: 'state', isFixed: false, options: ['with_data']}]}
        defaultGroups={
          store.roles.includes(15)
            ? []
            : [
                {group: 'manager', isFixed: false},
                // {group: 'pixel', isFixed: false},
              ]
        }
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields}
        disabledByDefault={[
          'qualified_cr_deposit_3',
          'qualified_cr_deposit_4',
          'qualified_cr_deposit_5',
          'deposit_1_median_amount',
          'deposit_1_cr_deposit_3',
          'deposit_1_cr_deposit_4',
          'deposit_1_cr_deposit_5',
          'deposit_2_median_amount',
          'deposit_2_median_time',
          'deposit_2_cr_deposit_4',
          'deposit_2_cr_deposit_5',
          'deposit_3_median_amount',
          'deposit_3_cr_deposit_5',
          'deposit_3_median_time',
          'deposit_4_median_amount',
          'deposit_4_median_time',
          'deposit_5_median_amount',
          'deposit_5_median_time',
        ]}
      >
        <Filters
          facebookStatisticsFilters={getListFilters()}
          facebookStatisticsGroups={getListGroups()}
          childrenRefresh={false}
          childrenHead={null}
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns columns={baseFields} />
              <Presets />
              <FullScreen />
            </>
          }
          childrenByFilters={<Refresh />}
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Statistics);
